/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Back_ProductInputs */

const tr_katalog_desi_page_back_product = /** @type {(inputs: Katalog_Desi_Page_Back_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün sayfasına geri dön`)
};

const en_katalog_desi_page_back_product = /** @type {(inputs: Katalog_Desi_Page_Back_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to product page`)
};

const de_katalog_desi_page_back_product = /** @type {(inputs: Katalog_Desi_Page_Back_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Produktseite`)
};

const ru_katalog_desi_page_back_product = /** @type {(inputs: Katalog_Desi_Page_Back_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад на страницу товара`)
};

/**
* | output |
* | --- |
* | "Back to product page" |
*
* @param {Katalog_Desi_Page_Back_ProductInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_back_product = /** @type {((inputs?: Katalog_Desi_Page_Back_ProductInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Back_ProductInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_back_product(inputs)
	if (locale === "de") return de_katalog_desi_page_back_product(inputs)
	if (locale === "ru") return ru_katalog_desi_page_back_product(inputs)
	return tr_katalog_desi_page_back_product(inputs)
});